import { ImpType } from '../_models/impression-type';

export const FLOOR_TYPES: ImpType[] = ['BANNER', 'VIDEO', 'NATIVE', 'AUDIO'];
